import { Versions } from '../constants/versions';
import { Agent } from './agent';
import { IActor } from '../resources/istatement/actor';
import { Group } from './group';
import { IGroup } from '../resources/istatement/group';
import { Verb } from './verb';
import { IVerb } from '../resources/istatement/verb';
import { StatementRef } from './statement_ref';
import { Activity } from './activity';
import { Result } from './result';
import { Context } from './context';
import { IStatement } from '../resources/istatement/statement';

export interface SubStatementParams {
	actor?: Agent | Group | IActor | IGroup;
	verb?: Verb | IVerb;
	target?: Activity | Agent | Group | StatementRef | SubStatement | IActor | IGroup;
	object?: Activity | Agent | Group | StatementRef | SubStatement | IActor | IGroup;
	result?: Result;
	context?: Context;
	timestamp?: Date;
}

export class SubStatement {
	objectType: string = 'SubStatement';
	actor?: Agent | Group;
	verb?: Verb;
	target?: Activity | Agent | Group | StatementRef | SubStatement;
	result?: Result;
	context?: Context;
	timestamp?: Date;

	constructor(cfg: SubStatementParams = {}) {
		if (cfg.object) {
			cfg.target = cfg.object;
		}

		if (cfg.actor) {
			if (typeof cfg.actor.objectType === 'undefined' || cfg.actor.objectType === 'Person') {
				cfg.actor.objectType = 'Agent';
			}

			if (cfg.actor.objectType === 'Agent') {
				if (cfg.actor instanceof Agent) {
					this.actor = cfg.actor;
				} else {
					this.actor = new Agent(cfg.actor);
				}
			} else if (cfg.actor.objectType === 'Group') {
				if (cfg.actor instanceof Group) {
					this.actor = cfg.actor;
				} else {
					this.actor = new Group(cfg.actor);
				}
			}
		}
		if (cfg.verb) {
			if (cfg.verb instanceof Verb) {
				this.verb = cfg.verb;
			} else {
				this.verb = new Verb(cfg.verb);
			}
		}
		if (cfg.target) {
			if (
				cfg.target instanceof Activity ||
				cfg.target instanceof Agent ||
				cfg.target instanceof Group ||
				cfg.target instanceof SubStatement ||
				cfg.target instanceof StatementRef
			) {
				this.target = cfg.target;
			} else {
				if (typeof cfg.target.objectType === 'undefined') {
					cfg.target.objectType = 'Activity';
				}

				if (cfg.target.objectType === 'Activity') {
					this.target = new Activity(cfg.target);
				} else if (cfg.target.objectType === 'Agent') {
					this.target = new Agent(cfg.target);
				} else if (cfg.target.objectType === 'Group') {
					this.target = new Group(cfg.target);
				} else if (cfg.target.objectType === 'SubStatement') {
					this.target = new SubStatement(cfg.target as any);
				} else if (cfg.target.objectType === 'StatementRef') {
					this.target = new StatementRef(cfg.target);
				} else {
					console.warn(`Unrecognized target type: ${cfg.target.objectType}`);
				}
			}
		}
		if (cfg.result) {
			if (cfg.result instanceof Result) {
				this.result = cfg.result;
			} else {
				this.result = new Result(cfg.result);
			}
		}
		if (cfg.context) {
			if (cfg.context instanceof Context) {
				this.context = cfg.context;
			} else {
				this.context = new Context(cfg.context);
			}
		}

		if (cfg.timestamp) {
			this.timestamp = cfg.timestamp;
		}
	}

	toString(lang: string = 'en-US'): string {
		return `${this.actor ? this.actor.toString(lang) : ''} ${this.verb ? this.verb.toString(lang) : ''} ${
			this.target ? this.target.toString(lang) : ''
		}`;
	}

	asVersion(version: Versions = '1.0.3'): IStatement {
		const timestamp = this.timestamp && this.timestamp;
		const objectType = this.objectType;
		const actor = this.actor && this.actor.asVersion(version);
		const verb = this.verb && this.verb.asVersion(version);
		const result = this.result && this.result.asVersion(version);
		const context = this.context && this.context.asVersion(version);
		const object = this.target && this.target.asVersion(version);

		const value: any = {
			objectType,
			actor,
			verb,
			result,
			context,
			object,
			timestamp
		};

		return value;
	}

	static fromJSON(subStJSON: string): SubStatement {
		const _subSt = JSON.parse(subStJSON);

		return new SubStatement(_subSt);
	}
}
